<!-- 结算操作 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn" style="font-size: 18px; font-weight: 700; margin: 5px">冲账前：</div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" v-loading="loading" :data="tableData" border="" ref="multipleTable" style="width: 100%; margin-bottom: 10px">
                <el-table-column show-overflow-tooltip width="52" type="index" label="序号"></el-table-column>
                <el-table-column show-overflow-tooltip width="180" prop="OrderCode" label="单号"></el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="OrderType" label="单据类型">
                    <template slot-scope="scope">
                        <i v-if="scope.row.OrderType == 0" class="c-active">销售收款</i>
                        <i v-else class="out-active">销售退货</i>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="TotalAmount" label="应收总额">
                    <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.TotalAmount : -scope.row.TotalAmount }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="AgentAmount" label="代收总额">
                    <template slot-scope="scope">{{ scope.row.IsAgent ? scope.row.AgentAmount : 0 }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="TotalAmount" label="实收总额">
                    <template slot-scope="scope">{{
                        scope.row.OrderType == 0 ? (scope.row.IsAgent ? scope.row.AgentAmount.toFixed(2) : scope.row.TotalAmount) : -scope.row.TotalAmount
                    }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip min-width="90" prop="Remark" label="备注"></el-table-column>
            </el-table>
        </div>
        <div class="search-ctn" style="font-size: 18px; font-weight: 700; margin: 5px">冲账后：</div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                v-loading="loading"
                :data="afterTableData"
                border=""
                ref="multipleTable"
                style="width: 100%; margin-bottom: 10px"
            >
                <el-table-column show-overflow-tooltip width="52" type="index" label="序号"></el-table-column>
                <el-table-column show-overflow-tooltip width="180" prop="OrderCode" label="单号"></el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="OrderType" label="单据类型">
                    <template slot-scope="scope">
                        <i v-if="scope.row.OrderType == 0" class="c-active">销售收款</i>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="TAmount" label="应收总额"> </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="AgentAmount" label="代收总额">
                    <template slot-scope="scope">{{ scope.row.IsAgent ? scope.row.AgentAmount : 0 }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" label="实收总额">
                    <template slot-scope="scope">{{ scope.row.AcAmount }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip min-width="90" prop="Remark" label="备注"></el-table-column>
            </el-table>
        </div>
        <div class="dialog-footer">
            <div class="re-submit">
                <el-button class="btn-primary" size="small" @click="submitForm()">提交</el-button>
                <el-button @click="cancel()" size="small">取消</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['OffSetList', 'OffsetType'],
    components: {},
    data() {
        return {
            loading: false,
            submitData: {
                OffsetType: 0,
                RecordIds: [],
                OrderCodes:''
            },
            tableData: [],
            afterTableData: []
        };
    },
    mounted() {
        if (this.OffSetList && this.OffSetList.length > 0) {
            this.submitData.OffsetType = this.OffsetType;
            this.tableData = this.OffSetList;
            let afterTList = this.OffSetList;
            let os = afterTList.filter(f => f.OrderType == 0);
            let order = os[0];
            let amount = Number(os[0].TotalAmount);
            let acAmount = os[0].IsAgent ? os[0].AgentAmount: Number(os[0].TotalAmount);
            this.submitData.OrderCodes='';
            if (os && os.length == 1) {
                for (let i = 0; i < afterTList.length; i++) {
                    this.submitData.RecordIds.push(afterTList[i].RecordId);
                    if (afterTList[i].OrderType == 1) {
                        amount -= Number(afterTList[i].TotalAmount);
                        if (!os[0].IsAgent) acAmount -= Number(afterTList[i].TotalAmount);
                    }
                    this.submitData.OrderCodes+=','+afterTList[i].OrderCode;
                }
                
                order.TAmount = amount.toFixed(2);
                order.AcAmount = acAmount.toFixed(2);
                this.afterTableData.push(order);
            } else this.$util.warningMsg('冲账数据异常，请刷新后重新操作');
        } else this.$util.warningMsg('冲账数据异常，请刷新后重新操作');
    },
    methods: {
        submitForm() {
            let that = this;
            if(that.loading)return false;
            if (that.submitData.RecordIds.length == 0) {
                that.$util.warningMsg('必须具备冲账条目');
                return;
            }
            that.loading = true;
            that.$util
                .axiosPost({
                    url: '/api/RevenueManagement_H/OffsetSettlementDatas',
                    data: that.submitData,
                    hideLoading: true
                })
                .then(res => {
                    that.$util.successMsg(res.errmsg);
                    if (res.errcode === 0) {
                        that.$emit('closeDialog', true);
                    }
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        cancel() {
            this.$emit('closeDialog');
        }
    }
};
</script>
<style lang="less" scoped>
.re-submit {
    text-align: right;
}
</style>
